var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1208,
    viewBox: "0 0 1920 1208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0.00976562V1208H1920V0Z",
    fill: "#210837"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3148_17571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1208
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0.00976562V1208H1920V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3148_17571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1865 501.952L-647.227 1351.29H-390.488L296.895 501.952L-383.659 -347.653H-645.507L36.1865 501.952Z",
    fill: "url(#paint0_linear_3148_17571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.7 501.982L-103.832 1518H203.292L1025.57 501.982L211.472 -514.364H-101.762L713.7 501.982Z",
    fill: "url(#paint1_linear_3148_17571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.51 501.952L591.1 1351.29H847.838L1535.22 501.952L854.678 -347.653H592.83L1274.51 501.952Z",
    fill: "url(#paint2_linear_3148_17571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.15 501.952L973.738 1351.29H1230.48L1917.86 501.952L1237.32 -347.653H975.468L1657.15 501.952Z",
    fill: "url(#paint3_linear_3148_17571)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.434 26.1934H0V1106.01H193.434V26.1934Z",
    fill: "#210837"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3148_17571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 194,
    height: 1081
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.434 26.1934H0V1106.01H193.434V26.1934Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3148_17571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4101 501.952L-682.003 1351.29H-425.264L262.118 501.952L-418.425 -347.653H-680.273L1.4101 501.952Z",
    fill: "url(#paint4_linear_3148_17571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.09 501.952L46.6865 1351.29H303.425L990.798 501.952L310.255 -347.653H48.4064L730.09 501.952Z",
    fill: "url(#paint5_linear_3148_17571)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3148_17571",
    x1: -175.167,
    y1: -162.91,
    x2: -175.167,
    y2: 1320.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1195,
    stopColor: "#210959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2313,
    stopColor: "#270A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#370C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#520F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    stopColor: "#771373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9055,
    stopColor: "#A71981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C21C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3148_17571",
    x1: 460.871,
    y1: -293.363,
    x2: 460.871,
    y2: 1480.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1195,
    stopColor: "#210959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2313,
    stopColor: "#270A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#370C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#520F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    stopColor: "#771373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9055,
    stopColor: "#A71981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C21C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3148_17571",
    x1: 1063.16,
    y1: -162.91,
    x2: 1063.16,
    y2: 1320.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1195,
    stopColor: "#210959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2313,
    stopColor: "#270A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#370C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#520F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    stopColor: "#771373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9055,
    stopColor: "#A71981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C21C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3148_17571",
    x1: 1445.8,
    y1: -70.5746,
    x2: 1445.8,
    y2: 1428.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1195,
    stopColor: "#210959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2313,
    stopColor: "#270A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#370C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#520F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    stopColor: "#771373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9055,
    stopColor: "#A71981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C21C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3148_17571",
    x1: -209.939,
    y1: -162.91,
    x2: -209.939,
    y2: 1320.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1195,
    stopColor: "#210959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2313,
    stopColor: "#270A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#370C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#520F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    stopColor: "#771373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9055,
    stopColor: "#A71981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C21C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3148_17571",
    x1: 518.742,
    y1: -162.91,
    x2: 518.742,
    y2: 1320.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1195,
    stopColor: "#210959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2313,
    stopColor: "#270A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#370C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#520F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    stopColor: "#771373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9055,
    stopColor: "#A71981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C21C89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearbg);
export default __webpack_public_path__ + "static/media/clearbg.cfb6158c19dbe6484ecae6bf230122fe.svg";
export { ForwardRef as ReactComponent };